import { useStore } from '@/store';
import { useSession } from '@/composables/session';
import BasketService from '@/services/basketService';

export function useBasket() {
    const store = useStore();
    const { currentUser, currentDebitor } = useSession();
    const basketService = new BasketService();

    async function createBasket() {
        if (currentUser.value?.email && currentDebitor.value) {
            try {
                const res = await basketService.CreateBasket(currentUser.value.email, currentDebitor.value.debitorNumber);
                currentDebitor.value.basketGuid = res.data;
                await getBasket();
            } catch (error) {
                console.error("Failed to create basket", error);
            }
        }
    }

    async function getBasket() {
        if (!currentDebitor.value) {
            store.basket = undefined;
            return;
        }

        if (currentDebitor.value.basketGuid) {
            try {
                const response = await basketService.GetBasket(currentDebitor.value.basketGuid);
                store.basket = response.data;
            } catch (error: any) {
                if (error.response?.status === 404) {
                    await createBasket();
                }
            }
        } else {
            await createBasket();
        }
    }

    return {
        getBasket,
        createBasket
    };
}
